import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Btn } from "@/components/Btn";
import { Logo } from "@/components/Logo";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full rounded-lg bg-ink-700 border border-chrome-dark text-white placeholder-slate-500 px-4 py-3 text-sm focus:border-signature focus:ring-1 focus:ring-signature outline-none transition-all";

  return (
    <div className="min-h-screen bg-ink-900 flex flex-col items-center justify-center px-4">
      <Seo title="Administration | Ronalp Enseigne" description="Espace d'administration." path="/admin/login" noindex />
      <div className="absolute inset-0 bg-grid bg-grid-fade opacity-20" />
      <Link to="/" className="relative mb-8 flex items-center gap-2 text-sm text-chrome-mid hover:text-white"><ArrowLeft className="h-4 w-4" /> Retour au site</Link>
      <form onSubmit={submit} className="relative w-full max-w-md rounded-2xl border border-white/10 bg-ink-800 p-8" data-testid="admin-login-form">
        <div className="flex justify-center mb-6"><Logo className="h-10" /></div>
        <div className="flex items-center justify-center gap-2 text-signature mb-6">
          <Lock className="h-4 w-4" /><span className="text-xs font-mono uppercase tracking-widest">Espace administration</span>
        </div>
        {error && <div className="mb-4 rounded-lg border border-signature/40 bg-signature/10 px-4 py-3 text-sm text-signature" data-testid="admin-login-error">{error}</div>}
        <label className="block text-xs font-mono uppercase tracking-wider text-chrome-mid mb-2">Email</label>
        <input className={input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@ronalp.com" data-testid="admin-email" required />
        <label className="block text-xs font-mono uppercase tracking-wider text-chrome-mid mb-2 mt-4">Mot de passe</label>
        <input className={input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-password" required />
        <Btn type="submit" className="mt-6 w-full" disabled={loading} data-testid="admin-login-submit">
          {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Connexion…</> : "Se connecter"}
        </Btn>
      </form>
    </div>
  );
}
